import { makeAutoObservable } from "mobx";
import type { RootStore } from "./root.store";
import {
  getVisibleProjectSettingsTabs,
  hasAnyProjectPermission,
  type IProjectSettingsTab,
  type TProjectSettingsTabKey,
} from "@/lib/permissions/project-permissions";

export class ProjectSettingsStore {
  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false } as never, { autoBind: true });
  }

  private get currentProject() {
    const { workspaceSlug, projectId } = this.rootStore.router;
    if (!workspaceSlug || !projectId) return undefined;
    return this.rootStore.project.getProjectById(workspaceSlug, projectId);
  }

  get visibleTabs(): IProjectSettingsTab[] {
    return getVisibleProjectSettingsTabs(this.currentProject);
  }

  get firstAccessibleTab(): IProjectSettingsTab | undefined {
    return this.visibleTabs[0];
  }

  canAccess(tabKey: TProjectSettingsTabKey): boolean {
    const tab = this.visibleTabs.find((item) => item.key === tabKey);
    return Boolean(tab);
  }

  canAccessAnyPermissions(permissions: IProjectSettingsTab["required"]): boolean {
    return hasAnyProjectPermission(this.currentProject, permissions);
  }
}
